import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import RecipeList from '../components/RecipeList';
import Bio from '../components/Bio';
import './Profile.css';
import { InputContext } from '../components/InputContext';

const baseURL = process.env.REACT_APP_API_URL;

const UserPage = () => {
    const { username } = useParams();
    const [recipes, setRecipes] = useState([]);
    const [imageSrc, setImageSrc] = useState(null);
    const navigate = useNavigate();
    const { username: currentUser } = useContext(InputContext);

    useEffect(() => {
        if (username === currentUser) {
            navigate('/profile');
        }
    }, [username, currentUser, navigate]);
    

    useEffect(() => {
        if (!username) return;

        fetch(`${baseURL}/user/${username}`)
            .then(res => res.json())
            .then(data => {
                if (data.profileImage) {
                    setImageSrc(`${baseURL}/uploads/profiles/${data.profileImage}`);
                }
            });

        const fetchUserRecipes = async () => {
            try {
                const response = await fetch(`${baseURL}/recipes/recipes-by-user/${username}`);
                if (!response.ok) throw new Error("Failed to fetch recipes");
                const data = await response.json();
                setRecipes(data);
            } catch (err) {
                console.error("Error fetching user's recipes:", err);
            }
        };

        fetchUserRecipes();
    }, [username]);

    return (
        <div className="profile-page">
            <Header />
            <div className="profile-heading">
                <div className="left-side">
                    <img
                        src={imageSrc || require('../assets/placeholder.jpg')}
                        alt="Profile"
                        className="profile-image"
                    />
                    <h2>{username}'s Profile</h2>
                </div>
                <div className="bio-box"><Bio username={username} canEdit={false} /></div>
            </div>

            <div style={{ marginLeft: '70px', marginBottom: '20px' }}>
                <h2>{username}'s Recipes</h2>
            </div>
            <RecipeList recipes={recipes} setRecipes={setRecipes} />
        </div>
    );
};

export default UserPage;